import styles from "./styles.module.css";
import InvoiceNumberSetUpForm from "components/utils/InvoiceNumberSetUpForm/InvoiceNumberSetUpForm";

export default function BillNumberSetUpPopup({ isOpen = true, onClose, onSuccess }) {
  if (!isOpen) return null;

  return (
    <div className={styles.popUp} onClick={onClose}>
      <div className={styles.contentWrapper} onClick={(e) => e.stopPropagation()}>
        <InvoiceNumberSetUpForm onClose={onClose} onSuccess={onSuccess} />
      </div>
    </div>
  );
}
